<template>
  <el-col :xs="24" :sm="12" class="my_cell_item">
    <div class="itnal_info_label">
      {{ label }}
      <slot name="label"></slot>
    </div>
    <div class="itnal_info_data">
      {{ value }}
      <slot name="value"></slot>
    </div>
  </el-col>
</template>

<script>
export default {
  props: ["label", "value"],
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.my_cell_item {
  margin-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
  .itnal_info_label {
    font-size: 16px;
    font-weight: 500;
    color: #5ba7ad;
    line-height: 22px;
    width: 50%;
  }
  .itnal_info_data {
    font-size: 16px;
    font-weight: 400;
    color: rgba(50, 50, 50, 1);
    line-height: 22px;
    min-height: 22px;
    width: 50%;
  }
}

@media screen and (max-width: 767px) {
  .my_cell_item {
    > div {
      width: 100% !important;
    }
  }
}
</style>
